<template>
    <div id="backdrop">
        <div id="color-wheel" class="md-layout md-gutter">
            <div id="default-colors">
                <h2><u>Default Color List</u></h2>
                <h5 v-for="(item, name) in colorlist" v-bind:key="name">
                    {{name}}
                    <span class="dot" @click="updateColor(item)" v-bind:style="{backgroundColor: item}"></span>
                </h5>
                <h6 id="clicker">
                    <small>Click one!</small>
                </h6>
            </div>
            <div id="picker">
                <color-picker v-model="color"></color-picker>
                <div id="inner-pick">
                    <b>Color: </b>
                    <input v-model="color" type="text">
                    <h4>Preview: <span class="dot" v-bind:style="{backgroundColor: color}"></span></h4>
                    <br><br>
                </div>
            </div>
        </div>
        <div id="how-to">
            <ul id="directions">
                <li>
                    <h4>Either a name from the default list or the hex color code are valid colors.</h4>
                    <h5>Example: 'BLACK' is the same as '#000000'. </h5>
                    <img src="../assets/ServiceCode.png"/>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import ColorPicker from 'vue-color-picker-wheel';
    import {COLORMAP}  from "../services/main";

    export default {

        components: {
            ColorPicker
        },
        created() {
            this.loadColors();
        },
        data() {
            return {
                color: '#000000',
                colorlist: {}
            };
        },
        methods: {
            loadColors() {
                const obj = {};
                for (let [key, value] of COLORMAP) {
                    obj[key] = value;
                }
                this.colorlist = obj;
            },
            updateColor(x) {
                this.color = x;
            }
        }
    };
</script>
<style scoped>

    #backdrop {
        background-color : white;
        margin-left      : 5%;
        margin-right     : 5%;
        height           : 100%;
    }

    #color-wheel {
        margin-top : 2%;
        display    : inline-block;
    }

    #picker {
        float       : left;
        margin-left : 40px;
    }

    #inner-pick {
        margin-top   : 20px;
        margin-right : 60px;
    }

    #default-colors {
        margin-left      : 5px;
        width            : 180px;
        background-color : white;
        text-align       : right;
        float            : left;
    }

    h5 {
        margin : 0px;
    }

    #how-to {
        display : block;
    }

    #directions {
        text-align : center;
        display    : inline-block;
    }

    .dot {
        margin           : 0px;
        height           : 15px;
        width            : 15px;
        background-color : #bbb;
        border-radius    : 50%;
        display          : inline-block;
    }
</style>